import { parse, format, addMinutes } from 'date-fns'
import id from 'date-fns/locale/id';
import omit from 'lodash/omit';

export function toTimeZone(date, timezone = null) {
  if (timezone == null) {return date;}

  const thisTimezone = date.getTimezoneOffset();
  const diff = thisTimezone - timezone;

  return addMinutes(date, diff);
}

/**
 * Poor man's timezone guesser.
 * Assuming that input is in ISO 8601 formatted string.
 */
export function extractTimezone(dateStr) {
  if (dateStr[dateStr.length - 1] === 'Z') {return 0;}
  const zone = dateStr.split(/(\+|-)/).slice(-2);
  const mark = zone[0] === '+' ? -1 : 1;
  const numbers = zone[1].split(':').map(e => parseInt(e, 10));
  const minutes = numbers[0] * 60 + numbers[1];

  return mark * minutes;
}

export function dateFormat(date, fmt = 'YYYY-MM-DD', timezone = null) {
  let dateToBeFormatted = date;
  let newTimezone;

  if (dateToBeFormatted == null) {
    dateToBeFormatted = new Date();
  }

  if (typeof date === 'string') {
    dateToBeFormatted = parse(date);
    newTimezone = extractTimezone(date);
  }
  if (timezone !== null) {newTimezone = timezone;}
  if (newTimezone !== null) {dateToBeFormatted = toTimeZone(dateToBeFormatted, newTimezone);}

  return format(dateToBeFormatted, fmt, { locale: id });
}

export function dateToObject(date, withTime = false) {
  let result = {
    date: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    second: date.getSeconds(),
  };

  if (!withTime) {
    result = omit(result, ['hour', 'minute', 'second']);
  }

  return result;
}
